import { cn } from '@dreamstack/util/src/cn'
import Image from 'next/image'
import type { ComponentProps } from 'react'

export const SimpleImage = ({
  aspectRatio,
  cover = true,
  className,
  imgClassName,
  alt = '',
  ...rest
}: {
  src: string
  aspectRatio: number
  cover?: boolean
  imgClassName?: string
} & Omit<ComponentProps<typeof Image>, 'fill'>) => {
  return (
    <div
      className={cn('relative h-0', className)}
      style={{ paddingTop: `${100 * (1 / aspectRatio)}%` }}
    >
      <Image
        {...rest}
        alt={alt}
        fill
        className={cn(cover ? 'object-cover' : 'object-contain', imgClassName)}
      />
    </div>
  )
}
